import { render, staticRenderFns } from "./ChargingPointEnergyPriceModule.vue?vue&type=template&id=3b12c4f0"
import script from "./ChargingPointEnergyPriceModule.vue?vue&type=script&lang=js"
export * from "./ChargingPointEnergyPriceModule.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointEnergyPriceModule.vue?vue&type=style&index=0&id=3b12c4f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports